import React, { useState } from 'react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { ShieldIcon, BarChartIcon, ScrollIcon, BuildingIcon, HeartIcon, UmbrellaIcon, CreditCardIcon, PiggyBankIcon, ArrowRightIcon, ChevronDownIcon, ChevronUpIcon, DollarSignIcon, LineChartIcon, BriefcaseIcon, UserIcon } from 'lucide-react';
const Services = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const services = [{
    category: 'Wealth & Investment Solutions',
    icon: <BarChartIcon size={32} className="text-primary" data-id="element-521" />,
    items: [{
      title: 'Portfolio Creation',
      description: 'Customized investment portfolios designed to meet your specific goals, risk tolerance, and time horizon.',
      features: ['Asset allocation strategies', 'Risk management', 'Regular portfolio reviews', 'Tax-efficient investing']
    }, {
      title: 'SRS Optimization',
      description: 'Maximize the benefits of your Supplementary Retirement Scheme (SRS) through strategic planning and investment selection.',
      features: ['Tax-saving strategies', 'SRS contribution planning', 'Investment selection', 'Withdrawal strategies']
    }, {
      title: 'Family Office Structuring',
      description: 'Comprehensive wealth management solutions for high-net-worth families seeking to preserve and grow their wealth across generations.',
      features: ['Wealth consolidation', 'Succession planning', 'Investment management', 'Family governance']
    }]
  }, {
    category: 'Insurance & Protection',
    icon: <ShieldIcon size={32} className="text-primary" data-id="element-522" />,
    items: [{
      title: 'Life Insurance',
      description: 'Protect your loved ones financially with comprehensive life insurance solutions tailored to your specific needs and budget.',
      features: ['Term life insurance', 'Whole life insurance', 'Universal life insurance', 'Critical illness coverage']
    }, {
      title: 'Health Insurance',
      description: 'Ensure you have access to quality healthcare with comprehensive health insurance coverage that complements your MediShield Life.',
      features: ['Integrated Shield Plans', 'Hospital income protection', 'Critical illness coverage', 'Disability income insurance']
    }, {
      title: 'Retirement Coverage',
      description: 'Plan for a comfortable retirement with solutions designed to provide stable income and financial security in your golden years.',
      features: ['Retirement income planning', 'CPF optimization', 'Annuity solutions', 'Long-term care protection']
    }]
  }, {
    category: 'Estate & Legacy Planning',
    icon: <ScrollIcon size={32} className="text-primary" data-id="element-523" />,
    items: [{
      title: 'Wills & Trusts',
      description: 'Ensure your assets are distributed according to your wishes with professionally drafted wills and trust arrangements.',
      features: ['Will creation and review', 'Trust establishment', 'Asset distribution planning', 'Beneficiary designation']
    }, {
      title: 'Lasting Power of Attorney (LPA)',
      description: 'Appoint trusted individuals to make decisions on your behalf should you lose mental capacity with proper LPA documentation.',
      features: ['LPA documentation', 'Donee selection guidance', 'Powers specification', 'Legal compliance']
    }, {
      title: 'Multi-generational Wealth Planning',
      description: 'Create strategies to preserve and transfer wealth across generations while minimizing taxes and potential conflicts.',
      features: ['Wealth transfer strategies', 'Family business succession', 'Education funding', 'Legacy preservation']
    }]
  }, {
    category: 'Corporate Solutions',
    icon: <BuildingIcon size={32} className="text-primary" data-id="element-524" />,
    items: [{
      title: 'Employee Benefits',
      description: 'Attract and retain top talent with comprehensive employee benefit packages that protect your team and their families.',
      features: ['Group life insurance', 'Group health insurance', 'Retirement plans', 'Flexible benefit options']
    }, {
      title: 'Business Insurance',
      description: 'Protect your business against unforeseen risks with tailored insurance solutions designed for your specific industry and needs.',
      features: ['Business continuity insurance', 'Key person insurance', 'Professional liability coverage', 'Property & casualty insurance']
    }, {
      title: 'Work Injury Compensation',
      description: 'Ensure compliance with Work Injury Compensation Act (WICA) requirements while protecting both your business and employees.',
      features: ['WICA compliance', 'Claims management', 'Risk assessment', 'Employee education']
    }, {
      title: 'Buy-Sell Agreement',
      description: 'Establish clear succession plans for business partners with legally binding buy-sell agreements funded by appropriate insurance.',
      features: ['Agreement structuring', 'Valuation methods', 'Funding strategies', 'Regular reviews']
    }]
  }];
  const faqs = [{
    question: 'How do I know which financial solutions are right for me?',
    answer: 'Our advisors conduct a comprehensive needs assessment to identify your specific goals, risk tolerance, and time horizon. We consider your assets, liabilities, family situation, and future aspirations to create a personalized financial plan that aligns with your unique circumstances.'
  }, {
    question: 'How often should I review my financial plan?',
    answer: 'We recommend reviewing your financial plan annually or whenever you experience a major life change—marriage, new home, children, career change. Our advisors proactively reach out for regular reviews to ensure your strategy evolves with your needs.'
  }, {
    question: 'What makes Magnavera Group different from other financial advisory firms?',
    answer: 'Magnavera Group distinguishes itself through our commitment to education, ethics, and empowerment. We focus on building long-term relationships, not just transactions. Our advisors are recognized for their expertise (many achieving MDRT status) and are committed to continuous professional development to serve you better.'
  }, {
    question: 'Do I need to have significant wealth to work with Magnavera Group?',
    answer: 'No we work with clients at various stages of their financial journey. Whether you re just starting to build wealth or managing substantial assets we tailor our approach to meet you where you are and help you progress toward your financial goals .'
  }];
  return <div className="w-full" data-id="element-525">
      {/* Page Header */}
      <section className="bg-primary py-16 relative overflow-hidden" data-id="element-526">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-527"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-528">
          <h1 className="text-white font-bold mb-4" data-id="element-529">Our Services</h1>
          <p className="text-white opacity-90 max-w-2xl mx-auto" data-id="element-530">
            Comprehensive financial solutions tailored to protect what matters
            most and help you achieve your goals.
          </p>
        </div>
      </section>
      {/* Intro Blurb */}
      <section className="py-12" data-id="element-531">
        <div className="container mx-auto px-4" data-id="element-532">
          <div className="max-w-3xl mx-auto text-center" data-id="element-533">
            <p className="text-text-secondary text-lg leading-relaxed" data-id="element-534">
              At Magnavera Group, we offer a wide range of financial solutions
              designed to meet your unique needs. Our advisors work with you to
              develop comprehensive strategies that protect your assets, grow
              your wealth, and secure your future.
            </p>
          </div>
        </div>
      </section>
      {/* Service Categories */}
      {services.map((category, categoryIndex) => <section key={categoryIndex} className={`py-16 ${categoryIndex % 2 === 0 ? 'bg-background' : 'bg-white'}`} data-id="element-535">
          <div className="container mx-auto px-4" data-id="element-536">
            <div className="flex items-center mb-12" data-id="element-537">
              <div className="mr-4" data-id="element-538">{category.icon}</div>
              <h2 className="font-bold" data-id="element-539">{category.category}</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-540">
              {category.items.map((service, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-card" data-id="element-541">
                  <h3 className="font-bold mb-3" data-id="element-542">{service.title}</h3>
                  <p className="text-text-secondary mb-4" data-id="element-543">
                    {service.description}
                  </p>
                  <h4 className="font-semibold mb-2" data-id="element-544">Key Features:</h4>
                  <ul className="grid grid-cols-2 gap-x-4 gap-y-2 mb-4" data-id="element-545">
                    {service.features.map((feature, i) => <li key={i} className="flex items-center" data-id="element-546">
                        <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-547"></div>
                        <span className="text-sm" data-id="element-548">{feature}</span>
                      </li>)}
                  </ul>
                  <Button href="/contact" variant="secondary" className="text-sm px-4 py-2" data-id="element-549">
                    Learn More
                  </Button>
                </div>)}
            </div>
            {categoryIndex === 3 && <div className="mt-10 p-6 bg-primary/10 rounded-lg" data-id="element-550">
                <p className="text-text-primary leading-relaxed" data-id="element-551">
                  We help you build a map for your company's financial journey
                  that involves analyzing past performance, identifying future
                  goals, and creating a roadmap to achieve them.
                </p>
              </div>}
          </div>
        </section>)}
      {/* Process Overview */}
      <section className="py-16 bg-white" data-id="element-552">
        <div className="container mx-auto px-4" data-id="element-553">
          <h2 className="text-center font-bold mb-12" data-id="element-554">Our Simple Process</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-555">
            {[{
            step: 1,
            title: 'Consultation',
            description: 'We start with a comprehensive needs assessment to understand your specific situation and requirements.',
            icon: <div className="w-16 h-16 rounded-full bg-primary text-white flex items-center justify-center text-2xl font-bold" data-id="element-556">
                    1
                  </div>
          }, {
            step: 2,
            title: 'Customized Solutions',
            description: 'Our advisors create personalized recommendations based on your needs and budget constraints.',
            icon: <div className="w-16 h-16 rounded-full bg-primary text-white flex items-center justify-center text-2xl font-bold" data-id="element-557">
                    2
                  </div>
          }, {
            step: 3,
            title: 'Ongoing Support',
            description: 'We provide continuous service, regular policy reviews, and dedicated assistance when you need it most.',
            icon: <div className="w-16 h-16 rounded-full bg-primary text-white flex items-center justify-center text-2xl font-bold" data-id="element-558">
                    3
                  </div>
          }].map((step, index) => <div key={index} className="text-center relative" data-id="element-559">
                <div className="flex justify-center mb-6" data-id="element-560">{step.icon}</div>
                <h3 className="font-bold mb-3" data-id="element-561">{step.title}</h3>
                <p className="text-text-secondary" data-id="element-562">{step.description}</p>
                {/* Connector line (hidden on mobile) */}
                {index < 2 && <div className="hidden md:block absolute top-8 left-[calc(50%+4rem)] right-0 h-0.5 bg-gray-200" data-id="element-563">
                    <ArrowRightIcon className="text-primary absolute right-0 -mt-2" size={20} data-id="element-564" />
                  </div>}
              </div>)}
          </div>
        </div>
      </section>
      {/* FAQ Preview */}
      <section className="py-16 bg-background" data-id="element-565">
        <div className="container mx-auto px-4" data-id="element-566">
          <h2 className="text-center font-bold mb-12" data-id="element-567">
            Frequently Asked Questions
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-568">
            {faqs.map((faq, index) => <div key={index} className="mb-4 border border-gray-200 rounded-lg overflow-hidden" data-id="element-569">
                <button className="w-full flex justify-between items-center p-4 bg-white text-left font-semibold" onClick={() => toggleFaq(index)} data-id="element-570">
                  {faq.question}
                  {openFaq === index ? <ChevronUpIcon size={20} className="flex-shrink-0 text-primary" data-id="element-571" /> : <ChevronDownIcon size={20} className="flex-shrink-0 text-primary" data-id="element-572" />}
                </button>
                {openFaq === index && <div className="p-4 bg-white border-t border-gray-200" data-id="element-573">
                    <p className="text-text-secondary" data-id="element-574">{faq.answer}</p>
                  </div>}
              </div>)}
          </div>
          <div className="text-center mt-8" data-id="element-575">
            <Button href="/faq" variant="secondary" data-id="element-576">
              View All FAQs
            </Button>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-primary py-16" data-id="element-577">
        <div className="container mx-auto px-4 text-center" data-id="element-578">
          <h2 className="text-white font-bold mb-4" data-id="element-579">
            Ready to Take Control of Your Financial Future?
          </h2>
          <p className="text-white opacity-90 max-w-2xl mx-auto mb-8" data-id="element-580">
            Contact us today for a free consultation and personalized financial
            strategy.
          </p>
          <Button href="/contact" variant="secondary" className="bg-white" data-id="element-581">
            Schedule a Consultation
          </Button>
        </div>
      </section>
    </div>;
};
export default Services;